import { useState, useEffect } from "react";
import { useParams, useHistory } from "react-router-dom";
import { convertToRaw } from "draft-js";
import { Editor } from "react-draft-wysiwyg";
import draftToHtml from "draftjs-to-html";

import EndConsultationModal from "./EndConsultationModal";
import Modal from "../../components/ModalUI";
import Button from "../../components/ButtonUI";
import SharedRequest from "../../components/SharedRequest";
import Spinner from "../../components/Spinner";
import makeToast from "../../components/Snackbar";
import Input from "../../components/Input";

import "./styles.scss";
import interdit from "../../assets/images/exclamation-mark.png";

import { retriveDemande2, seenByExpert, sendResponse } from "../../api/medecin";
import moment from "../../helper/moment";

const Consultation = () => {
  const params: any = useParams();
  const history: any = useHistory();
  const { idDemande } = params;
  const [quit, setQuit] = useState(false);

  const [loading, setLoading] = useState(false);
  const [demandeDetails, setDemandeDetails] = useState<any>();
  const [autoSaveAt, setAutoSaveAt] = useState(Date.now());
  const [endConsultationModal, setEndConsultationModal] = useState(false);
  const [editorState, setEditorState] = useState<any>();
  const [condition, setCondition] = useState<any>({ c: "", nbrJrs: "" });
  const [urgence, setUrgence] = useState<boolean>(false);
  const [diagnosticPreliminaire, setDiagnosticPreliminaire] = useState<string>("");
  const conditions = [
    { c: "Consultation dermatologique non indispensable", nbrJrs: "" },
    { c: "Consultation dermatologique   ", nbrJrs: "" },
    { c: "Exérèse indispensable  ", nbrJrs: "" },
  ];
  const onEditorStateChange = async (newState) => {
    setEditorState(newState);

    setAutoSaveAt(Date.now());
    //TODO localStorge draft
    try {
    } catch (error) {
      console.log("error", error);
    }
  };

  const sendDemandeResponse = async () => {
    if (demandeDetails) {
      await sendResponse(idDemande, {
        response: draftToHtml(convertToRaw(editorState.getCurrentContent())),
        urgence: urgence,
        recommendation: condition,
        diagnosticPreliminaire: diagnosticPreliminaire
      });

    }
  };

  const seenByExp = async () => {
    if (demandeDetails) {
      if (demandeDetails.status === "IN_PROGRESS") {
        await seenByExpert(idDemande, demandeDetails._id);
      }
    }
  };
  const _getDemandeById = async () => {
    setLoading(true);
    try {
      const response = await retriveDemande2(idDemande);
      setLoading(false);
      setDemandeDetails(response?.data.demande);
    } catch (error) {
      setLoading(false);
      console.log("error", error);
    }
  };

  useEffect(() => {
    _getDemandeById();
  }, []);

  useEffect(() => {
    // if (demandeDetails) _getPatientData();
    if (demandeDetails && demandeDetails.status === "RESPONSE") {
      makeToast("error", "Demande déjà traitée");

      history.push("/");
    }
  }, [demandeDetails]);

  return loading ? (
    <Spinner />
  ) : (
    <>
      <div className="grid grid-cols-2 divide-x">
        {demandeDetails ? (
          <>
            <div className="h-screen">
              <div className="flex flex-col gap-2 md:flex-row md:items-center md:justify-between border-b pb-4 mb-6">
                <div>
                  <h2 className="text-2xl font-bold text-gray-800 tracking-tight">Demande de téléexpertise en Dermatologie </h2>
                  <div className="flex items-center gap-2 mt-1 text-gray-500 text-sm">
                  <span>{moment(demandeDetails?.createdAt).format("DD MMMM yyyy")}</span>
                  {demandeDetails?.type && (
                    <span className="box ml-4">{demandeDetails?.type}</span>
                  )}
                  </div>
                </div>
                <div className="flexCenter space-x-5 mx-2">
                  <Button
                    width="119px"
                    height="50px"
                    onClick={() => {
                      setEndConsultationModal(true);
                      console.log("condition", condition);
                      console.log("urgence", urgence);
                      console.log("diagnosticPreliminaire", diagnosticPreliminaire);
                      console.log("editorState", draftToHtml(convertToRaw(editorState.getCurrentContent())));
                      setQuit(false);
                      //repondre
                    }}
                    disabled={
                      !editorState ||
                      (editorState &&
                        draftToHtml(
                          convertToRaw(editorState.getCurrentContent())
                        ).length < 9)
                    }
                  >
                    Répondre
                  </Button>
                </div>
                <div className="flexCenter space-x-5 mx-2">
                  <Button
                    width="119px"
                    height="50px"
                    status="secondary"
                    onClick={() => {
                      setQuit(true);
                      setEndConsultationModal(true);
                    }}
                  >
                    Quitter
                  </Button>
                </div>
              </div>
              <div className="mt-5 py-4 mb-3 inputax relative bg-white shadow-md px-4 rounded-lg">
                <span className="capitalize font-bold text-md">Recommandation</span>

                <div className="mt-4">
                {conditions.map((el, i) => {
                  const isSelected = condition?.c === el.c;

                  return (
                    <div 
                      key={i} 
                      style={{ 
                        marginBottom: "12px", 
                        padding: "12px", 
                        border: "1px solid", 
                        borderColor: isSelected ? "#3b82f6" : "#e5e7eb", 
                        borderRadius: "8px",
                        backgroundColor: isSelected ? "#eff6ff" : "transparent"
                      }}
                    >
                      <label style={{ display: "table", cursor: "pointer", width: "100%" }}>
                        <div style={{ display: "table-cell", verticalAlign: "middle", width: "24px" }}>
                          <input
                            type="radio"
                            name="condition-group"
                            checked={isSelected}
                            onChange={() => setCondition(el)}
                            style={{ margin: "0", cursor: "pointer" }}
                          />
                        </div>
                        <div style={{ display: "table-cell", verticalAlign: "middle", paddingLeft: "12px" }}>
                          <span
                            style={{
                              fontSize: "0.875rem",
                              fontWeight: isSelected ? "600" : "400",
                              color: isSelected ? "#111827" : "#6b7280",
                              display: "block"
                            }}
                          >
                            {el.c}
                          </span>
                        </div>
                      </label>

                      {isSelected && el.c !== "Consultation dermatologique non indispensable" && (
                        <div style={{ marginLeft: "36px", marginTop: "12px" }}>
                          <span style={{ fontSize: "0.875rem", color: "#4b5563", marginRight: "8px" }}>
                            Dans un délai de
                          </span>
                          <div style={{ display: "inline-block", position: "relative" }}>
                            <input
                              type="number"
                              placeholder="0"
                              defaultValue={condition.nbrJrs}
                              onBlur={(e) =>
                                setCondition({
                                  ...condition,
                                  nbrJrs: e.target.value,
                                })
                              }
                              style={{
                                width: "100px",
                                padding: "6px 40px 6px 10px",
                                fontSize: "0.875rem",
                                border: "1px solid #d1d5db",
                                borderRadius: "6px",
                                outline: "none"
                              }}
                            />
                            <span style={{ 
                              position: "absolute", 
                              right: "10px", 
                              top: "50%", 
                              transform: "translateY(-50%)", 
                              fontSize: "0.75rem", 
                              color: "#9ca3af",
                              pointerEvents: "none"
                            }}>
                              jours
                            </span>
                          </div>
                        </div>
                      )}
                    </div>
                  );
                })}
              </div>
                <div className="flex items-center gap-6 mt-4">
                  <span className="font-bold text-md">Diagnostic préliminaire :</span>

                  {["CA", "ML", "Non concerné"].map((option) => (
                    <label key={option} className="flex items-center gap-2 cursor-pointer">
                      <input
                        type="radio"
                        name="diagnosticPreliminaire"
                        value={option}
                        checked={diagnosticPreliminaire === option}
                        onChange={(e) => setDiagnosticPreliminaire(e.target.value)}
                      />
                      <span
                        className={`text-sm ${
                          diagnosticPreliminaire === option
                            ? "font-bold text-black"
                            : "text-gray-400"
                        }`}
                      >
                        {option}
                      </span>
                    </label>
                  ))}
                </div>
              </div>
              
              <div
                className="inputax relative h-12 border bg-white shadow-md rounded-lg w-full mb-2.5"
                style={{ lineHeight: "48px" }}
              >

                <img
                  src={interdit}
                  alt="info"
                  style={{
                    display: "inline-block",
                    width: "20px",
                    height: "20px",
                    marginLeft: "12px",
                    verticalAlign: "middle",
                    objectFit: "contain" 
                  }}
                />


                <p 
                  className="text-sm font-bold"
                  style={{
                    display: "inline-block",
                    margin: "0 12px", 
                    verticalAlign: "middle",
                    lineHeight: "normal"
                  }}
                >
                  Urgence
                </p>


                <div
                  style={{
                    display: "inline-block",
                    verticalAlign: "middle",
                    height: "48px",
                    padding: "20px"
                  }}
                >
                  <Input
                    name="urgence"
                    type="checkbox"
                    onChange={() => setUrgence(!urgence)}
                    labelText={""}
                    labelProps={{
                      className: `check text-sm ${urgence ? "" : "text-gray-400"}`,
                    }}
                    checked={urgence}
                    stylesDiv={""}
                  />
                </div>
              </div>
              <div className="mt-5 mb-3 bg-white rounded-lg h-fit shadow-md ">
                <span className="  capitalize font-bold text-md"></span>
                <Editor
                  editorState={editorState}
                  wrapperClassName="consultation-editor"
                  editorClassName="consultation-editor "
                  onEditorStateChange={onEditorStateChange}
                  placeholder="Rédiger votre avis ici ..."
                  editorStyle={{ height: "388px", padding: "8px" }}
                />
              </div>
              <div className="text-center">
                <span className="card-subtitle">
                  Enregistré automatiquement à{" "}
                  {moment(autoSaveAt).format("hh:mm")}✓
                </span>
              </div>
            </div>
            <SharedRequest
              demandeData={demandeDetails}
              colorIndex={0}
              consultaionPage={true}
              setOpenModal={() => console.log("")}
              teleexpert={true}
            />
          </>
        ) : (
          <Spinner />
        )}

        <Modal
          showModal={endConsultationModal}
          closeModal={() => setEndConsultationModal(false)}
        >
          <EndConsultationModal
            closeModal={() => setEndConsultationModal(false)}
            idConsultation={idDemande}
            openPrescriptionModal={() => sendDemandeResponse()}
            seenByExpert={() => seenByExp()}
            quit={quit}
          />
        </Modal>
      </div>
    </>
  );
};

export default Consultation;
